import React, {useEffect} from "react";
import {Button, Drawer, Form, Input, Select, TreeSelect} from "antd";
import {useModel} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const AreaForm = () => {
    const [{materialSortDict}, {getMaterialSortDict}] = useModel("cmDict");
    const [{userInfo}] = useModel("global");

    useEffect(() => {
        getMaterialSortDict();
    }, []);

    const [form] = Form.useForm();
    const [
        {selectedWarehouse, selectedArea, warehouseList, areaActionType,},
        {insertArea, updateArea, setAreaDrawerVisible, loadArea}
    ] = useModel("warehouse");

    useEffect(() => {
        if (areaActionType === CM_ACTION_TYPE.INSERT) {
            form.resetFields();
            form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
        } else if (areaActionType === CM_ACTION_TYPE.EDIT) {
            form.resetFields();
            form.setFieldsValue(selectedArea);
        }
    }, [areaActionType, selectedWarehouse, selectedArea]);

    const onFinish = () => {
        if (areaActionType === CM_ACTION_TYPE.INSERT) {
            form.validateFields().then(async data => {
                data.warehouseId = selectedWarehouse.id;
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;
                await insertArea({showMsg: true, data});
                loadArea({showMsg: false, data: {warehouseId: selectedWarehouse.id, pageSize: 100,pageNum:1}});
                setAreaDrawerVisible(false);
            });
        } else if (areaActionType === CM_ACTION_TYPE.EDIT) {
            form.validateFields().then(async data => {                
                data.warehouseId = selectedArea.warehouseId;
                data.id = selectedArea.id;
                data.orgId = userInfo.orgId;
                data.orgName = userInfo.orgName;

                // return console.log(data)
                // "id":"8575e8159203428381c2c55ab448248f",
                // "warehouseId":"8575e8159203428381c2c55ab448248f",
                // "orgId":"7878",
                // "areaName":"999",
                // "areaDesc":"7878"
                await updateArea({showMsg: true, data});
                loadArea({showMsg: false, data: {warehouseId: selectedWarehouse.id, pageSize: 100,pageNum:1}});
                setAreaDrawerVisible(false);
            });
        }
    }

    const onReset = () => {
        form.resetFields();
        form.setFieldsValue({warehouseName: !!selectedWarehouse ? selectedWarehouse.warehouseName : ""});
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
              onFinish={onFinish}>
            <Form.Item name="warehouseName" label="所属仓库" rules={[{required: true, message: '请选择所属仓库',}]}>
                {/*<Select
                    showSearch
                    allowClear={true}
                    placeholder="所属仓库"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={warehouseList.map(el => ({label: el.warehouseName, value: el.id}))}
                />*/}
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name="areaCode" label="区域编码" rules={[{required: true, message: '请输入区域编码',}]}>
                <Input/>
            </Form.Item>
            <Form.Item name="areaName" label="区域名称" rules={[{required: true, message: '请输入区域名称',}]}>
                <Input/>
            </Form.Item>
            {/* <Form.Item name="materialType" label="配件类型">
                <TreeSelect
                    showSearch
                    allowClear
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    placeholder="请选择商品类别"
                    treeDefaultExpandAll
                    onChange={() => {
                    }}
                    treeData={materialSortDict}
                />
            </Form.Item> */}
            <Form.Item name="areaDesc" label="备注" rules={[{required: false}]}>
                <Input.TextArea/>
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    {areaActionType === CM_ACTION_TYPE.INSERT ? "添加" : "修改"}
                </Button>
                <Button htmlType="button" onClick={onReset} className="margin-left-8">
                    重置
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{areaDrawerVisible}, {setAreaDrawerVisible}] = useModel("warehouse");
    return (
        <Drawer
            title="区域信息"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setAreaDrawerVisible(false)
            }}
            visible={areaDrawerVisible}
        >
            <AreaForm/>
        </Drawer>
    )
}